export var UserRole;
(function (UserRole) {
    UserRole["Admin"] = "ADMIN";
    UserRole["Distributor"] = "DISTRIBUTOR";
    UserRole["Support"] = "SUPPORT";
    UserRole["User"] = "USER";
})(UserRole || (UserRole = {}));
//# sourceMappingURL=authApiTypes.js.map